import { styled } from "styled-components";

const RulesListContainer = styled.div`
  flex: 1 1 auto;
  overflow-y: auto;
  opacity: 1;
  gap: 8px;
  padding: 0 8px;
`;

export default RulesListContainer;
